import React from 'react';

export default function TextElement({
  content,
  position,
  size,
  style,
  scale = 1,
  fontScaleFactor = 1,
  messengerStyle = false,
}) {
  // For messenger style, we'll use a more visible design with clear borders
  if (messengerStyle) {
    console.log('Rendering TextElement in messenger style:', content?.substring(0, 30) + (content?.length > 30 ? '...' : ''));
    
    // Format text content to handle line breaks properly
    const formattedContent = content?.split('\n\n').map((paragraph, index) => (
      <p key={index} style={{ marginBottom: index < (content?.split('\n\n').length - 1) ? '10px' : '0' }}>
        {paragraph}
      </p>
    ));
    
    return (
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '100%',
          marginBottom: '0',
        }}
      >
        <div
          style={{
            backgroundColor: '#FFFFFF',
            color: '#000000',
            padding: '12px 16px',
            borderRadius: '16px',
            width: '100%',
            maxWidth: '100%',
            fontSize: `${parseInt(style?.fontSize || '16') * scale * fontScaleFactor}px`,
            fontFamily: style?.fontFamily || 'Arial, sans-serif',
            lineHeight: style?.lineHeight || '1.5',
            fontWeight: style?.fontWeight || 'normal',
            fontStyle: style?.fontStyle || 'normal',
            textDecoration: style?.textDecoration || 'none',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word',
            boxSizing: 'border-box',
            height: 'auto'
          }}
        >
          {formattedContent || 'No content'}
        </div>
      </div>
    );
  }

  // Original non-messenger style
  return (
    <div 
      style={{
        position: 'absolute',
        left: `${position.x * scale}px`,
        top: `${position.y * scale}px`,
        width: `${size.width * scale}px`,
        height: `${size.height * scale}px`, // fixed box height so vertical centering works reliably
        display: 'flex',
        alignItems: (() => {
          const v = (style?.verticalAlign || 'top').toString().toLowerCase();
          if (v === 'middle' || v === 'center') return 'center';
          if (v === 'bottom') return 'flex-end';
          return 'flex-start'; // top
        })(),
        padding: '0px',
        overflow: 'hidden', // Clip text that exceeds container height
      }}
    >
      <div 
        style={{
          width: '100%',
          fontSize: `${parseInt(style?.fontSize || '16') * scale * fontScaleFactor}px`,
          fontFamily: style?.fontFamily || 'Arial',
          color: style?.color || '#000000',
          textAlign: style?.textAlign || 'left',
          lineHeight: style?.lineHeight || '1.5',
          fontWeight: style?.fontWeight || 'normal',
          fontStyle: style?.fontStyle || 'normal',
          textDecoration: style?.textDecoration || 'none',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
        }}
      >
        {content || ''}
      </div>
    </div>
  );
}
